import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useContext } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { MedicalRecordContext } from 'context';
import * as selectors from 'modules/PatientResults/selectors';
import styles from '../GlucoseConcentrationLevels.pcss';
import { calculateCGMRangeTime } from './helpers';
const AggregateValue = ({ aGCL })=>{
    const medicalRecord = useContext(MedicalRecordContext);
    const showGoals = useSelector(selectors.showCGMGoals);
    const { dataType } = medicalRecord;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.aggregate__value, {
            'mr-2': dataType === 'BGM' || showGoals
        }),
        children: [
            dataType === 'BGM' ? aGCL.count : `${aGCL.percentage}%`,
            dataType === 'CGM' && /*#__PURE__*/ _jsx("div", {
                className: styles.aggregate__time,
                children: calculateCGMRangeTime(aGCL)
            })
        ]
    });
};
export default /*#__PURE__*/ memo(AggregateValue);
